export default "__VITE_ASSET__CVJvysp0__"